import { render, staticRenderFns } from "./MoleculeContentBlockVideo.vue?vue&type=template&id=288d56a8&"
import script from "./MoleculeContentBlockVideo.vue?vue&type=script&lang=js&"
export * from "./MoleculeContentBlockVideo.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeContentBlockVideo.vue?vue&type=style&index=0&id=288d56a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports